// removed by extract-text-webpack-plugin
module.exports = {"placeholderGray":"#9297A3","borderGray":"#D3D6DC","valueBlack":"#222628","lightGray":"rgba(211, 214, 220, 0.3)","container":"container-2crGO","iconContainer":"iconContainer-2fWZi","icon":"icon-2Yugc","calendarIcon":"calendarIcon-e51Hu icon-2Yugc","closeIcon":"closeIcon-1sAnd icon-2Yugc","hidden":"hidden-3t4Gk","toggleButtons":"toggleButtons-2P0bI","withLabel":"withLabel-6X3g9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/forms/DateTimeField/_dateTimeField.css
// module id = 1189
// module chunks = 1